import React from 'react';
import styled from 'styled-components';

/**
 * Container 컴포넌트 Props
 * @typedef {Object} ContainerProps
 * @property {React.ReactNode} children - 컨테이너 내부에 표시할 콘텐츠
 * @property {string} [title] - 컨테이너 상단에 표시할 제목 (선택사항)
 * @property {string} [className] - 외부에서 스타일을 커스터마이징하기 위한 className
 * @property {string} [padding] - 컨테이너의 패딩 값 (기본값: '10px 20px 60px')
 */

/**
 * 공용 컨테이너 컴포넌트
 * 
 * @example
 * // 제목이 있는 경우
 * <Container title="그룹 관리">
 *   <div>내용</div>
 * </Container>
 * 
 * @example
 * // 제목이 없는 경우
 * <Container>
 *   <div>내용</div>
 * </Container>
 * 
 * @example
 * // Fragment를 children으로 사용
 * <Container title="대시보드">
 *   <>
 *     <div>내용 1</div>
 *     <div>내용 2</div>
 *   </>
 * </Container>
 * 
 * @example
 * // 커스텀 패딩 사용
 * <Container title="설정" padding="20px 30px 40px">
 *   <div>내용</div>
 * </Container>
 * 
 * @example
 * // className으로 스타일 커스터마이징
 * <Container title="프로필" className="custom-container">
 *   <div>내용</div>
 * </Container>
 */
const Container = ({ children, title, className, padding }) => {
  return (
    <Wrapper className={className} $padding={padding}>
      {title && (
        <TitleWrapper>
          <Title>{title}</Title>
        </TitleWrapper>
      )}
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  padding: ${({ $padding }) => $padding || '10px 20px 60px'};
`;

const TitleWrapper = styled.div`
  padding-bottom: 8px;
`;

const Title = styled.h2`
  margin: 0;
  padding: 5px 0;
  font-size: 1.4rem;
  font-family: 'Nanum Gothic', sans-serif;
`;

export default Container;
